import * as yup from "yup"

export const createValidationSchema = questions => {
    const requiredString = yup.string().nullable().required("Answer is required")

    const notRequiredString = yup.string().nullable().notRequired()

    const answerSchema = questions.reduce((schema, question) => {
        const answerRequired = !question.isFreeResponse && !question.isOptional
        schema[question.id] = yup.object().shape({
            answer: answerRequired ? requiredString : notRequiredString,
            free_response: question.isFreeResponse && !question.isOptional ? requiredString : notRequiredString
        })
        return schema
    }, {})

    return yup.object().shape(answerSchema)
}
